export const tabletLargeText = `
@media (min-width: 767px) {
    font-size: 18px;
  } ;
`

export const tabletSmallText = `
@media (min-width: 767px) {
    font-size: 14px;
  } ;
`

export const tabletMediumText = `
@media (min-width: 767px) {
    font-size: 16px;
  } ;
`

export const tabletXlText = `
@media (min-width: 767px) {
    font-size: 22px;
  } ;
`
export const tablet2XlText = `
@media (min-width: 767px) {
    font-size: 26px;
  } ;
`

export const tabletSVGWidth = `
@media (min-width: 767px) {
    width: 80px;
  } ;
`

export const tabletOperationButton = `
@media (min-width: 767px) {
    width: 26px;
    height: 26px
  } ;
`

